import {
	btn,
	comp,
	Component,
	fieldset,
	form,
	p,
	router,
	tbar,
	TextField,
	textfield,
	win,
	Window
} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {ServerApi} from "./util/ServerApi.js";
import {IfwInvalidator} from "./util/IfwInvalidator.js";

export class PasswordReset extends Component {

	private subtitle: Component;
	private passwordFld: TextField;
	private passwordConfirmFld: TextField;

	constructor(token: string, userId: string) {
		super("section");
		this.itemId = "password-reset";
		this.id = "password-reset";
		this.cls = "card";

		const f = form({
				handler: async () => {
					const v = f.value;
					v.id = userId;
					v.token = token;
					delete v.passwordConfirm;
					const url = ServerApi.url("auth/users/" + userId + "/resetpassword", {
						userId: userId,
						token: token
					}, false);
					ServerApi.call(url, {password: v.password}, "POST")
						.then(response => {
							if (!response.success) {
								IfwInvalidator.setInvalidPasswordMessage(this.passwordFld, response.data.validationErrors.password);
								return false;
							} else {
								const w = win({
										title: t("Success"),
										draggable: false,
										width: 480,
										height: 240,
										closable: false,
										maximizable: false,
										resizable: false,
										collapsible: false,
										modal: true
									}, comp({
										cls: "vbox pad",
										flex: 1
									}, p({text: t("Your password has been reset. Continue to the login screen.")}))
									, tbar({cls: "ifw-bbar"},
										btn({
											cls: "primary", text: t("Continue"),
											handler: () => {
												router.goto("login");
												w.close();
											}
										})));
								w.show();
							}
						})
						.catch((reason) => {
							if(reason.type == "invalidProperties") {
								IfwInvalidator.setInvalidPasswordMessage(this.passwordFld, reason.validationErrors["password"]);
							} else {
								void Window.error(reason);
							}
							this.passwordFld.focus();
						});


				}
			},
			fieldset({},
				comp({
						tagName: "div",
						cls: "ifw-title-cnt"
					},
					comp({
						tagName: "h3",
						cls: "ifw-title",
						text: t("Reset your password")
					}),
					this.subtitle = comp({
						tagName: "h4",
						cls: "ifw-subtitle",
						text: t("Please create a new password for {username}"),
					}),
				),

				this.passwordFld = textfield({
					label: t("Password"),
					name: "password",
					id: "password",
					type: "password",
					required: true,
					icon: "lock",
					autocomplete: "off",
					listeners: {
						change: ({newValue}) => {
							const dupe = this.passwordConfirmFld.value;
							if (dupe && dupe !== newValue) {
								this.passwordConfirmFld.setInvalid(t("The passwords don't match"));
							}
						},
						invalid: IfwInvalidator.setTranslatedErrorMsg
					}
				}),

				this.passwordConfirmFld = textfield({
					label: t("Confirm password"),
					name: "passwordConfirm",
					id: "passwordConfirm",
					type: "password",
					required: true,
					icon: "lock",
					autocomplete: "off",
					listeners: {
						change: ({target, newValue}) => {
							const dupe = this.passwordFld.value;
							if (dupe && dupe !== newValue) {
								target.setInvalid(t("The passwords don't match"))
							}
						},
						invalid: IfwInvalidator.setTranslatedErrorMsg
					}
				})
			),
			tbar({cls: "ifw-bbar"}, "->",
				btn({html: t("Cancel"), route: "login"}),
				btn({html: t("Ok"), type: "submit"})
			)
		); //form

		this.items.add(f);

		this.on("render", () => {
			const url = ServerApi.url("auth/forgotpassword/" + userId, {resetToken: token}, false);
			ServerApi.call(url, {}, "GET").then((response) => {
				this.subtitle.html = t("Please create a new password for {username}").replace("{username}", response.data.username);
			}).catch((_response) => {
				router.goto("login")
			});
		});
	}
}